import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';
import { Reply } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import DataTable from '../../../components/DataTable/DataTable';
import ResponseDialog from './ResponseDialog';
import { approvementTypeLabelKey } from './approvement-type.helper';
import { useRecoilValue } from 'recoil';
import { rolePermission } from '../../../recoil-store/recoil-state';

const useStyles = makeStyles(theme => ({
    button: {
        textTransform: 'none',
        color: '#3f51b5'
    }
}));
/**
 * @Description This function lets you return component.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function AllBots(props) {
    const { open, fetchData, setOpen, customColumn, setCustomColumn, searchData, loading, setSearchKeyData } = props;
    const { t } = useTranslation();
    const classes = useStyles();
    const label = 'CONTENT.PUBLISH-APPROVE.';
    const permissions = useRecoilValue(rolePermission);

    useEffect(() => {
        const column = [{
            id: 5,
            name: '',
            label: ' ',
            options: { filter: false, sort: false }
        }, {
            id: 0,
            name: props.type === 'bot' ? 'approvement_id' : 'integration_approvements_id',
            label: ' ',
            options: {
                filter: false, sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    if (searchData && searchData[dataIndex]) {
                        return <span>{dataIndex + 1}.</span>;
                    }
                }
            }
        }, {
            id: 1,
            name: 'bot_type',
            label: t(label + 'BOT-TYPE'),
            options: {
                filter: true, sort: true,
                // AR-7737: service catalog requests are labelled "Service"; approve/reject still sends bot_type 'autom'.
                customBodyRenderLite: (dataIndex) => {
                    const row = searchData && searchData[dataIndex];
                    if (!row) {
                        return null;
                    }
                    const key = approvementTypeLabelKey(row);
                    return <span data-testid="approvement-type">{key ? t(key) : row.bot_type}</span>;
                }
            }
        }, {
            id: 2,
            name: 'name',
            label: t(label + 'NAME'),
            options: { filter: true, sort: true }
        }, {
            id: 3,
            name: 'version',
            label: t(label + 'VERSION'),
            options: { filter: true, sort: true }
        }, {
            id: 4,
            name: 'status',
            label: t(label + 'STATUS'),
            options: { filter: true, sort: false }
        }, {
            id: 5,
            name: 'published_by_fullname',
            label: t(label + 'PUBLISHED-BY'),
            options: { filter: true, sort: true }
        }, {
            id: 6,
            name: 'actions',
            label: t(label + 'ACTIONS'),
            options: {
                filter: false, sort: false, display: permissions?.data.includes('INTEGRATIONMARKET_PUBLISHAPPROVE') ? true : 'excluded',
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    if (searchData && searchData[dataIndex]) {
                        return (
                            <Button disabled={open.open} className={classes.button} onClick={() => { setOpen({ open: true, bot: searchData[dataIndex], type: 'approve' }); }}>
                                <Reply />
                            </Button>
                        );
                    }
                }
            }
        }];
        setCustomColumn(column);
        setSearchKeyData(['bot_type', 'name', 'status', 'published_by_fullname']);
    }, [t, searchData]);

    return (
        <div id="requesttab-container">
            <DataTable
                customColumns={customColumn}
                selectableRows="none"
                data={searchData}
                title={t('CONTENT.REQUEST-TAB.REQUEST-LIST')}
                loading={loading}
            />
            {open.open && <ResponseDialog setOpen={setOpen} open={open} fetchData={fetchData} tabIndex={1} type={props.type} />}
        </div>
    );
}

export default AllBots;